<!--
  One LINE-theme preview: a real LINE chat screen (HTML/CSS) rendered inside the
  iPhone outline frame. CSS custom properties carry the per-theme colours so the
  same markup themes itself from `designTokens` + wallpaper. Capture a clean
  screenshot per theme via /line?only=<key>.
-->
<div class="line-stage">
  <div class="phone"
       [style.--surface]="surface"
       [style.--accent]="accent"
       [style.--accent-text]="accentText"
       [style.--fg]="foreground"
       [style.--incoming]="incoming"
       [style.--incoming-text]="incomingText"
       [style.--incoming-border]="incomingBorder"
       [style.--outgoing-border]="outgoingBorder"
       [style.--scrim]="scrim"
       [style.--header-bg]="headerBg"
       [style.--header-text]="headerText"
       [style.--input-bg]="inputBg"
       [style.--input-fg]="inputFg"
       [style.--input-pill]="inputPill"
       [style.--field-emoji-fill]="emojiFill || null">

    <!-- chat screen (clipped to the rounded interior; frame outline sits on top) -->
    <div class="screen">
      <div class="wallpaper" [class.kawaii]="useKawaii"
           [style.background]="useKawaii ? skinColor : null"
           [style.background-image]="!useKawaii && background ? 'url(' + background + ')' : null">
        <app-line-chat-bg *ngIf="useKawaii" [product]="product"></app-line-chat-bg>
      </div>

      <!-- iOS status bar (time + signal / wifi / battery; the Dynamic Island
           comes from the frame image, so we draw around it) -->
      <div class="statusbar">
        <span class="time">9:41</span>
        <!-- iOS status-bar right cluster (signal / wifi / battery). The PNG is a
             solid silhouette used as a CSS mask, so it always paints in --fg,              the same colour as the time, and adapts to light/dark themes. -->
        <span class="status-right" aria-hidden="true"></span>
      </div>

      <!-- header -->
      <div class="header">
        <span class="chevron"></span>
        <span class="avatar" [style.background-image]="logo ? 'url(' + logo + ')' : null"></span>
        <span class="titles">
          <span class="title">{{ name }}</span>
        </span>
        <span class="header-actions">
          <svg viewBox="0 0 20 20" aria-hidden="true" class="ic">
            <circle cx="8.5" cy="8.5" r="6" fill="none" stroke-width="1.8"></circle>
            <line x1="13" y1="13" x2="18" y2="18" stroke-width="1.8"></line>
          </svg>
          <svg viewBox="0 0 20 18" aria-hidden="true" class="ic">
            <line x1="1" y1="3"  x2="19" y2="3"  stroke-width="1.8"></line>
            <line x1="1" y1="9"  x2="19" y2="9"  stroke-width="1.8"></line>
            <line x1="1" y1="15" x2="19" y2="15" stroke-width="1.8"></line>
          </svg>
        </span>
      </div>

      <!-- conversation -->
      <div class="chat">
        <div class="row in">
          <span class="row-av" [style.background-image]="logo ? 'url(' + logo + ')' : null"></span>
          <div class="bubble in">Love this theme</div>
        </div>
        <div class="row out">
          <span class="stamp">9:41</span>
          <div class="bubble-wrap">
            <div class="bubble out">Looks great!</div>
          </div>
        </div>
      </div>

      <!-- input bar -->
      <div class="inputbar">
        <svg viewBox="0 0 20 20" class="ic" aria-hidden="true">
          <line x1="10" y1="3" x2="10" y2="17" stroke-width="1.8"></line>
          <line x1="3" y1="10" x2="17" y2="10" stroke-width="1.8"></line>
        </svg>
        <svg viewBox="0 0 22 18" class="ic" aria-hidden="true">
          <rect x="1" y="4" width="20" height="12" rx="3" fill="none" stroke-width="1.6"></rect>
          <circle cx="11" cy="10" r="3.4" fill="none" stroke-width="1.6"></circle>
          <rect x="7" y="2" width="6" height="3" rx="1"></rect>
        </svg>
        <svg viewBox="0 0 20 18" class="ic" aria-hidden="true">
          <rect x="1" y="2" width="18" height="14" rx="2.5" fill="none" stroke-width="1.6"></rect>
          <circle cx="6" cy="7" r="2"></circle>
          <path d="M2 15l5-5 4 4 3-3 4 4" fill="none" stroke-width="1.6"></path>
        </svg>
        <span class="field">
          <span class="field-aa">Aa</span>
          <svg viewBox="0 0 20 20" class="field-emoji" aria-hidden="true">
            <circle cx="10" cy="10" r="8" fill="none" stroke-width="1.6"></circle>
            <circle cx="7" cy="8" r="1"></circle>
            <circle cx="13" cy="8" r="1"></circle>
            <path d="M6 12.5a5 5 0 0 0 8 0" fill="none" stroke-width="1.6"></path>
          </svg>
        </span>
        <svg viewBox="0 0 14 20" class="ic" aria-hidden="true">
          <rect x="4" y="1" width="6" height="11" rx="3"></rect>
          <path d="M1.5 9a5.5 5.5 0 0 0 11 0" fill="none" stroke-width="1.6"></path>
          <line x1="7" y1="14.5" x2="7" y2="18.5" stroke-width="1.6"></line>
        </svg>
      </div>
    </div>

    <!-- iPhone outline frame + Dynamic Island, drawn on top of the screen -->
    <img class="frame" [src]="frameSrc" alt="" aria-hidden="true">
  </div>
</div>
